"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryCount = exports.lastUpdated = exports.headers = exports.status = exports.isPending = exports.isFinished = exports.getQueryDetails = void 0;

var _queryKey = require("../lib/query-key");

var _reselect = require("reselect");

var defaultDetailsObject = {
  isFinished: false,
  isPending: false,
  headers: null,
  queryCount: 0
};

var getQueryDetails = function getQueryDetails(queriesState, queryConfig) {
  var _ref;

  var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

  if (!queryKey) {
    return defaultDetailsObject;
  }

  return ((_ref = queriesState) != null ? _ref[queryKey] : _ref) || defaultDetailsObject;
};

exports.getQueryDetails = getQueryDetails;
var isFinished = (0, _reselect.createSelector)(getQueryDetails, function (query) {
  return query.isFinished;
});
exports.isFinished = isFinished;
var isPending = (0, _reselect.createSelector)(getQueryDetails, function (query) {
  return query.isPending;
});
exports.isPending = isPending;
var status = (0, _reselect.createSelector)(getQueryDetails, function (query) {
  return query.status;
});
exports.status = status;
var headers = (0, _reselect.createSelector)(getQueryDetails, function (query) {
  return query.headers;
});
exports.headers = headers;
var lastUpdated = (0, _reselect.createSelector)(getQueryDetails, function (query) {
  return query.lastUpdated;
});
exports.lastUpdated = lastUpdated;
var queryCount = (0, _reselect.createSelector)(getQueryDetails, function (query) {
  return query.queryCount;
});
exports.queryCount = queryCount;